import React, { Fragment } from 'react';
import Cookies from 'js-cookie';

import VBInput from "@vb-js-commons/new/vbInput";
import VBPhoneInput from "@vb-js-commons/new/vbPhoneInput";
import VBLoadingScreen from "@vb-js-commons/vbLoadingScreen";
import { Dialog, TwButton as Button, Icon } from '@ui-component-library';

import { validateEmail} from '../api';
import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Opt from '../components/editor/Helpers';

class BrevoSignUpForm extends React.Component {
    constructor() {
        super();

        this.state = {
            formData:{
                email:"",
                name: "",
                mobile: "-"
            },
            errors:{
                email: null,
                name: null
            },
            confirmModal: false
        }

    }




    handleSubmit(e) {
        e.preventDefault();

        let checkList = [];
        let data = this.state.formData


        if ((!data.email || !validateEmail(data.email))) {
            this.setState({errors:{email: "Den här e-postadressen ser inte ut att vara korrekt"}})
            return;
        }

        if (this.props.includeMobile) {
            if ((!data.mobile || !isValidPhoneNumber(data.mobile))) {
                this.setState({errors:{mobile: "Det här mobilnumret ser inte ut att vara korrekt"}})
                return;
            }
        }

        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
        }
        return fetch("/cms-api/add-hs-list/",{
            method: 'POST',
            credentials: 'same-origin',
            headers: headers,
            body:JSON.stringify({"email": data.email, "list_id": this.props.list_id, "mobile": data.mobile })
            }).then((resp) => {
                if(resp.status >= 200 && resp.status <= 299){
                    this.setState({confirmModal: true});
                } else{
                    alert("Något gick fel, Försök igen senare eller kontakta oss.")
                }
            })
        
       
    }

    render() {
        return (<Fragment>
            <VBLoadingScreen show_loading={this.state.loading} />
            <div className={`${this.props.theme}`}>
                <form onSubmit={(e) => { this.handleSubmit(e) }} className={`${this.props.textColor}`}>
                <VBInput
                        type="email"
                        label={<p className='subtitle mb-[5px] mt-[20px]'>Ange din mailadress:</p>}
                        placeholder="E-postadress"
                        error={this.state.errors.email}
                        onFocus={() => this.setState({ errors: { ...this.state.errors, email: '' } })}
                        onChange={(val) => {this.setState({ formData: { ...this.state.formData, email: val } }); }} 
                    />

                    <VBInput
                        type="text"
                        label={<p className='subtitle mb-[5px] mt-[20px]'>Ange ditt namn:</p>}
                        placeholder="Namn"
                        error={this.state.errors.name}
                        onFocus={() => this.setState({ errors: { ...this.state.errors, name: '' } })}
                        onChange={(val) => {this.setState({ formData: { ...this.state.formData, name: val } }); }} 
                    />
                    {this.props.includeMobile?
                    <VBPhoneInput
                    label={<p className='subtitle mb-[5px] mt-[20px]'>Ange ditt mobilnummer:</p>}
                    placeholder="Mobilnummer"
                    error={this.state.errors.mobile}
                    onChange={(val) => {this.setState({ formData: { ...this.state.formData, mobile: val } }); }} 
                    /> : null}

                    <button type="submit" className={`n-btn ${this.props.button.variant} px-[60px] mt-[30px]`}>{this.props.button.text}</button>

                    <p className='caption text-left mt-[20px]'>Genom att klicka på knappen ovan godkänner du våra <a href="/terms/" className='supp-forest-green underline underline-offset-2'>användarvillkor </a> och <a href='/privacy/' className='supp-forest-green underline underline-offset-2'>integritetspolicy.</a></p>
                </form>
            </div>

            

            <Dialog isOpen={this.state.confirmModal} size="small">
                <Dialog.Header>
                    <p className="fs-4 neutral-charcoal mb-0">{this.props?.confirmDialog?.heading || "Du är nu anmäld!"}</p>
                    <Button variant="tertiary" size="icon" onClick={() => this.setState({ confirmModal: false })}>
                        <Icon name="CrossSimple" className="color-charcoal-500" size="large" />
                    </Button>
                </Dialog.Header>
                <Dialog.Content>
                    <p className='neutral-charcoal'>{this.props?.confirmDialog?.text || "Inom kort kommer ett bekräftelse mejl till din anginva E-post"}</p>
                </Dialog.Content>
                <Dialog.Footer className="flex flex-row justify-end border-0">
                    <a type="button" href={this.props?.confirmDialog?.buttonLink || "#"} onClick={() => {this.setState({confirmModal: false})}} className="n-btn btn-forest-green btn-sm float-end">{this.props?.confirmDialog?.buttonText || "Stäng"}</a>
                </Dialog.Footer>
            </Dialog>
        </Fragment>)
    }
}
BrevoSignUpForm.defaultProps={
    textColor: "primary-dark",
    button:{
        variant:"btn-forest-green",
        text: "Anmäl mig"
    },
    confirmModal: {
        heading: "Du är nu anmäld!",
        text: "Inom kort kommer ett bekräftelse mejl till din anginva E-post",
        buttonLink: "#",
        buttonText: "Stäng"
    },
    list_id: 77
}
BrevoSignUpForm.fields={
    list_id:{
        type: "text",
    },
    textColor:{
        type: "select",
        options: Opt.colorVariables
    },
    includeMobile:{
        type: "radio",
        options: [
            {label: "Yes", value: true},
            {label: "No", value: false}
        ]
    },
    button: {
        type: "object",
        objectFields: {
            variant: { type: "select", options: Opt.buttonOptions },
            text: {type: "text"}
        }
    },
    confirmModal: {
        type: "object",
        objectFields: {
            heading: {type: "text"},
            text: {type: "text"},
            buttonLink: {type: "text"},
            buttonText: {type: "text"},
        }
    }
}

export default BrevoSignUpForm;